var r = /* @__PURE__ */ ((b) => (b.Box = "box", b.Table = "table", b.Card = "card", b.List = "list", b))(r || {});
export {
  r as M
};
//# sourceMappingURL=Module.types-B1FfGGac.js.map
